import { create } from "zustand";

type AppState = {
  transactionId: string;
  isProcessing: boolean;
  isFailedRegistration: boolean;
  setTransactionId: (id: string) => void;
  setIsProcessing: (val: boolean) => void;
  setIsFailedRegistration: (val: boolean, transactionId: string) => void;
  reset: () => void;
};

export const useStore = create<AppState>((set) => ({
  transactionId: "",
  isProcessing: false,
  isFailedRegistration: false,
  setTransactionId: (id) => set({ transactionId: id }),
  setIsProcessing: (val) => set({ isProcessing: val }),
  setIsFailedRegistration: (val, transactionId) => set({ isFailedRegistration: val, transactionId }),
  reset: () => set({ transactionId: "", isProcessing: false, isFailedRegistration: false }),
}));
